/**
 * 功能开关配置
 * 根据环境变量控制不同部署版本的功能
 */

// 部署模式
export type DeployMode = 'private' | 'public';

// 写作模式
export type WritingMode = 'static' | 'ai-generated';

// 功能开关
export const features = {
  // 部署模式：private（私有版）或 public（公开版）
  deployMode: (import.meta.env.VITE_DEPLOY_MODE || 'private') as DeployMode,
  
  // 写作模式：static（静态题库）或 ai-generated（AI生成）
  writingMode: (import.meta.env.VITE_WRITING_MODE || 'static') as WritingMode,
  
  // 是否启用数据同步
  enableSync: import.meta.env.VITE_ENABLE_SYNC !== 'false',
  
  // 是否需要邀请码
  requireInviteCode: import.meta.env.VITE_REQUIRE_INVITE_CODE === 'true',
  
  // 设备名额上限（0 表示不限制）
  deviceQuota: parseInt(import.meta.env.VITE_DEVICE_QUOTA || '0', 10),
};

// 便捷判断
export const isPublicDeploy = features.deployMode === 'public';
export const isAIWriting = features.writingMode === 'ai-generated';
export const needsInviteCode = features.requireInviteCode && isPublicDeploy;
